import React, { useEffect, useMemo, useState } from 'react';
import '../../../../Assets/Css/AddTask.scss';
import { customStyle } from '../../../../Components/Style';
import Select from 'react-select';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { connect } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { FaUserCircle } from 'react-icons/fa';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { MdKeyboardArrowUp } from 'react-icons/md';
import AddTaskModal from '../../../../Components/AddTaskCategoryModal';
import AddLabelModal from '../../../../Components/AddLabelModal';
import { addTask, addTaskCategory, addTaskLabel, deleteTaskCategory, deleteTaskLabel, getTaskCategoryList, getTaskLabelList, updateTask, getTasks } from '../../../../Services/Task/action';
import { getUsers } from '../../../../Services/Users/action';
import { addTimesheet, updateTimesheet } from '../../../../Services/TimeSheet/action';
import { toast } from 'react-toastify';
import { getProjectMilestones, getprojects } from '../../../../Services/Project/action';

const Priority = [
    { value: 'High', label: 'High' },
    { value: 'Medium', label: 'Medium' },
    { value: 'Low', label: 'Low' },
];

const OptionRenderer = ({ data }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaUserCircle
                style={{
                    width: '20px',
                    height: '20px',
                    color: '#ced4da',
                    marginRight: '10px',
                }}
            />
            <span>{data.label}</span>
        </div>
    );
};

const EmpProjectAddTask = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location?.state?.data?.allData;
    const { projectId } = useParams();

    const pathname = location?.pathname;
    useEffect(() => {
        setTimeout(() => {
            fetchData();
        }, 200)
    }, []);

    const fetchData = async () => {
        try {
            await Promise.all([
                props?.getUsers({ module: 'users-names' }),
                props?.getTaskCategoryList(),
                props?.getTaskLabelList(),
                props?.getprojects(),
                props?.getTasks(),
                props?.getProjectMilestones(),
            ])
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
    };

    const [showDetails, setShowDetails] = useState(false);

    const [Addtaskmodal, setaddTaskModal] = useState(false);
    const [Addlabelmodal, setaddLabelModal] = useState(false);
    const [ProjectAssignedTo, setProjectAssignedTo] = useState();

    const openTaskModal = () => setaddTaskModal(true);
    const closeTaskModal = async () => {
        setaddTaskModal(false);
        await fetchData();
    }

    const openLabelModal = () => setaddLabelModal(true);
    const closeLabelModal = () => setaddLabelModal(false);

    const toggleDetails = () => {
        setShowDetails((prev) => !prev);
    };

    const currentProject = useMemo(() => {
        return props?.project?.filter((project) => project?.id === Number(projectId));
    }, [props?.project, projectId]);

    const ProjectCategory = currentProject

    useEffect(() => {
        const assignedOptions = ProjectCategory?.[0]?.projectUserMap
            .map((map) => {
                const user = map?.userProjectMap;
                if (!user) return null;
                return {
                    label: user?.name,
                    value: user?.id,
                    id: user?.id,
                };
            })
            .filter(Boolean);

        setProjectAssignedTo(assignedOptions)
    }, [currentProject])


    const TaskCategory = props?.taskCategory?.map((item) => {
        return {
            label: item?.category_name,
            value: item?.category_name,
        }
    });

    const Label = props?.taskLabel?.map((item) => {
        return {
            label: item?.label_name,
            value: item?.label_name,
        }
    })

    const initialState = {
        title: null,
        assignedTo: null,
        project: null,
        taskcategory: null,
        start_date: null,
        due_date: null,
        without_due_date: false,
        description: '',
        label: null,
        milestones: null,
        priority: null,
        make_private: false,
        billable: false,
        time_estimate: false,
        time_taken_hours: '',
        time_taken_minutes: '',
        repeat: false,
        independent_task: false,
        dependentTask: null
    };

    const [clientData, setClientData] = useState(initialState);

    useEffect(() => {
        if (ProjectCategory && ProjectCategory.length > 0) {
            setClientData((prev) => ({
                ...prev,
                project: ProjectCategory[0]
            }));
        }
    }, [ProjectCategory]);

    const taskOptions = props?.task
        ?.filter((task) => {
            const isEditMode = !!data;
            const selectedProjectId = clientData?.project?.id || data?.project?.id;
            if (selectedProjectId) {
                if (isEditMode) {
                    return task?.project?.id === selectedProjectId && task?.id !== data?.id;
                }
                return task?.project?.id === selectedProjectId;
            }
            return false;
        })
        .map((task) => ({
            id: task?.id,
            label: task?.title,
        }));

    const Milestones = props?.projectMilestones
        ?.filter(item => (clientData?.project?.[0]?.projectMilestones?.id || clientData?.project?.projectMilestones?.id) == item?.id)
        ?.map((item) => {
            return {
                label: item?.name,
                value: item?.name,
            }
        });

    const taskData = useMemo(() => {
        if (!data || ProjectAssignedTo?.length === 0) return null;

        const taskSource = data;

        return {
            title: taskSource?.title,
            assignedTo: ProjectAssignedTo?.filter((user) =>
                taskSource?.taskUserMap?.some((taskUser) => taskUser?.userTaskMap?.name === user?.value)
            ),
            project: ProjectCategory?.find((item) => item?.id === taskSource?.project?.id),
            taskcategory: TaskCategory?.find((item) => item?.value === taskSource?.task_category?.category_name),
            label: Label?.find((item) => item?.value === taskSource?.label?.label_name),
            start_date: taskSource?.start_date,
            due_date: taskSource?.due_date,
            without_due_date: !taskSource?.due_date,
            description: taskSource?.description,
            milestones: Milestones?.find((item) => item?.value === taskSource?.milestone),
            priority: Priority?.find((item) => item?.value === taskSource?.priority),
            make_private: !!taskSource?.make_private,
            billable: !!taskSource?.billable,
            time_estimate: !!taskSource?.time_taken_estimate,
            time_taken_hours: taskSource?.time_taken_estimate
                ? taskSource?.time_taken_estimate?.match(/(\d+)\s*hr\s*(\d+)?\s*min?/)[1] ?? ""
                : "",
            time_taken_minutes: taskSource?.time_taken_estimate
                ? taskSource?.time_taken_estimate?.match(/(\d+)\s*hr\s*(\d+)?\s*min?/)[2] ?? ""
                : "",
            repeat: !!taskSource?.repeat,
            independent_task: !!taskSource?.task_is_independent,
            dependentTask: taskOptions?.find((task) => task?.id === taskSource?.parent_task_id),
        };
    }, [data, pathname, ProjectAssignedTo, ProjectCategory, TaskCategory, Label, Milestones, Priority, taskOptions]);

    useEffect(() => {
        if (taskData && !clientData?.assignedTo) {
            setClientData(taskData);
        }
    }, [taskData]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setClientData((preVal) => ({
            ...preVal,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        try {
            if (clientData?.independent_task && !clientData?.dependentTask) {
                toast.error("Please select a parent task for this dependent task.");
                return;
            }

            if (!clientData?.title || !clientData?.start_date || (!clientData?.without_due_date && !clientData?.due_date)) {
                toast.error("Please fill all the required fields.")
                return;
            }

            const assignToEmployeeId = clientData.assignedTo?.map(assigned => assigned.value) || [];

            const body = {
                title: clientData.title,
                description: clientData.description,
                assignTo_employeeId: assignToEmployeeId,
                task_category_id: props?.taskCategory?.filter(category => clientData?.taskcategory?.value === category?.category_name)?.map(category => category?.id)[0],
                start_date: clientData.start_date,
                due_date: clientData.due_date,
                milestone: clientData.milestones?.value,
                priority: clientData.priority?.value,
                label_id: props?.taskLabel?.filter(label => clientData?.label?.value === label?.label_name)?.map(label => label?.id)[0],
                project_id: clientData.project?.id,
                make_private: clientData?.make_private,
                billable: clientData?.billable,
                time_taken_estimate: clientData?.time_estimate ? `${clientData?.time_taken_hours} hr ${clientData?.time_taken_minutes} min` : '',
                repeat: clientData?.repeat,
                task_is_independent: clientData?.independent_task,
                parent_task_id: clientData?.independent_task ? clientData?.dependentTask?.id : null,
                sub_task_id: 1,
                status: "Incomplete",
                assigned_by: props?.user?.id
            }

            if (data) {
                await props?.updateTask(data?.id, body, true);
            }
            else {
                await props?.addTask(body);
            }
            navigate(-1)
        } catch (error) {
            console.error("Error in adding data:", error)
        }
    };

    const mainContent = (
        <div className="addTask-main">
            <div className="page-title">
                <h4> {pathname?.includes('add') ? "Add" : "Update"}  Task </h4>
                <div className="edit-btn">
                    <button type="submit" className="custom-btn" onClick={() => navigate(-1)}>
                        {props.loading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            'Cancel'
                        )}
                    </button>

                    <button type="submit" className="custom-btn" onClick={handleSubmit}>
                        {props.loading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            'Save'
                        )}
                    </button>
                </div>
            </div>

            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="left-part p-4">
                            <div className="custom-row">
                                <div className="add-project-detail">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className="label">Title <span style={{ color: 'red' }}>*</span></h6>
                                                <input
                                                    type="text"
                                                    className="input-css"
                                                    name="title"
                                                    disabled={props.loading}
                                                    value={clientData?.title}
                                                    placeholder="Enter a task title"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-6 task-catagory">
                                            <div className="input-group">
                                                <h6 className="label">Task Category</h6>
                                                <Select
                                                    options={TaskCategory}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                        }),
                                                    }}
                                                    value={clientData?.taskcategory}
                                                    placeholder="---"
                                                    onChange={(val) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            taskcategory: val,
                                                        }));
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#5757fe',
                                                            primary: '#5757fe',
                                                        },
                                                    })}
                                                />
                                            </div>
                                            <button onClick={openTaskModal}>add</button>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className="label">Project</h6>
                                                <Select
                                                    options={ProjectCategory}
                                                    getOptionLabel={(e) => e.name}
                                                    getOptionValue={(e) => e.id}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                        }),
                                                    }}
                                                    value={clientData?.project}
                                                    placeholder="---"
                                                    onChange={(val) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            project: val,
                                                        }));
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#5757fe',
                                                            primary: '#5757fe',
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mt-0">
                                            <div className="col-lg-3">
                                                <div className="input-group">
                                                    <h6 className="label">Start Date <span style={{ color: 'red' }}>*</span></h6>
                                                    <DatePicker
                                                        styles={customStyle}
                                                        selected={clientData?.start_date ? new Date(clientData?.start_date) : null}
                                                        placeholderText="Select Date"
                                                        onChange={(date) => {
                                                            // setClientData((preVal) => ({
                                                            //     ...preVal,
                                                            //     start_date: date.toISOString().split('T')[0],
                                                            // }));
                                                            const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                                .toISOString()
                                                                .split('T')[0];

                                                            setClientData((preVal) => ({
                                                                ...preVal,
                                                                start_date: localDate,
                                                            }));
                                                        }}
                                                        dateFormat="dd-MM-yyyy"
                                                        name="transaction_date"
                                                        disabled={props.loading}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: '#5757fe',
                                                                primary: '#5757fe',
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            {!clientData?.without_due_date && (<div className="col-lg-3">
                                                <div className="input-group">
                                                    <h6 className="label">Deadline <span style={{ color: 'red' }}>*</span></h6>
                                                    <DatePicker
                                                        styles={customStyle}
                                                        selected={clientData?.due_date ? new Date(clientData?.due_date) : null}
                                                        placeholderText="Select Date"
                                                        onChange={(date) => {
                                                            setClientData((preVal) => ({
                                                                ...preVal,
                                                                due_date: date.toISOString().split('T')[0],
                                                            }));
                                                        }}
                                                        dateFormat="dd-MM-yyyy"
                                                        name="transaction_date"
                                                        disabled={props.loading}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: '#5757fe',
                                                                primary: '#5757fe',
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </div>)}

                                            <div className="col-lg-4 col-md-4 col-sm-6 due_date_radio">
                                                <div className="radiobtn">
                                                    <input type="checkbox" defaultChecked={
                                                        data ?
                                                            data?.due_date ? false : true
                                                            : false} value={clientData?.without_due_date} onChange={(e) => {
                                                                setClientData((preVal) => ({
                                                                    ...preVal,
                                                                    without_due_date: e.target.checked,
                                                                }))
                                                            }} />
                                                    <lable className="label">Without Due Date</lable>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-9">
                                            <div className="input-group">
                                                <h6 className="label">Assigned To</h6>
                                                <Select
                                                    options={ProjectAssignedTo}
                                                    getOptionLabel={(option) => (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                                            <span>{option.label}</span>
                                                            {option.id === props.user.id && (
                                                                <span style={{ fontSize: '0.8em', color: '#fff', backgroundColor: '#888', padding: '0px 4px 0px 4px', borderRadius: '4px' }}>It's you</span>
                                                            )}
                                                        </div>
                                                    )}
                                                    getOptionValue={(option) => option.value}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                            width: '100%',
                                                        }),
                                                        control: (provided) => ({
                                                            ...provided,
                                                            boxShadow: 'none',
                                                            border: '1px solid #ced4da',
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: '#6c757d',
                                                        }),
                                                    }}
                                                    value={clientData?.assignedTo}
                                                    placeholder="---"
                                                    onChange={(selectedOptions) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            assignedTo: selectedOptions,
                                                        }));
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#5757fe',
                                                            primary: '#5757fe',
                                                        },
                                                    })}
                                                    isSearchable
                                                    isMulti
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="note-part">
                                                <h6 className="label">Description</h6>
                                                <div className="editor-custom">
                                                    <CKEditor
                                                        data={data?.description || ""}
                                                        editor={ClassicEditor}
                                                        onReady={(editor) => {
                                                            console.log('Editor is ready to use!', editor);
                                                        }}
                                                        onChange={(event, editor) => {
                                                            const data = editor.getData();
                                                            console.log({ event, editor, data });
                                                            setClientData((preVal) => ({
                                                                ...preVal,
                                                                description: data,
                                                            }));
                                                        }}
                                                        onBlur={(event, editor) => {
                                                            console.log('Blur.', editor);
                                                        }}
                                                        onFocus={(event, editor) => {
                                                            console.log('Focus.', editor);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <h5 className="other-detail-divider">
                                        Other Details
                                        <span
                                            onClick={toggleDetails}
                                            style={{ cursor: 'pointer', marginLeft: '5px', fontSize: '30px' }}
                                        >
                                            {showDetails ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                        </span>
                                    </h5>
                                    {showDetails && (
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="card-type">
                                                    <label className="labeling task-catagory">
                                                        <div className="input-group">
                                                            <h6 className="label">Label</h6>
                                                            <Select
                                                                options={Label}
                                                                styles={{
                                                                    ...customStyle,
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        zIndex: 2,
                                                                    }),
                                                                }}
                                                                value={clientData?.label}
                                                                placeholder="---"
                                                                onChange={(val) => {
                                                                    setClientData((preVal) => ({
                                                                        ...preVal,
                                                                        label: val,
                                                                    }));
                                                                }}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#5757fe',
                                                                        primary: '#5757fe',
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                        <button onClick={openLabelModal}>add</button>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div className="card-type">
                                                    <label className="labeling">
                                                        <div className="input-group">
                                                            <h6 className="label">Milestones</h6>
                                                            <Select
                                                                options={Milestones}
                                                                styles={{
                                                                    ...customStyle,
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        zIndex: 2,
                                                                    }),
                                                                }}
                                                                value={clientData?.milestones}
                                                                placeholder="---"
                                                                onChange={(val) => {
                                                                    setClientData((preVal) => ({
                                                                        ...preVal,
                                                                        milestones: val,
                                                                    }));
                                                                }}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#5757fe',
                                                                        primary: '#5757fe',
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div className="card-type">
                                                    <label className="labeling">
                                                        <div className="input-group">
                                                            <lable className="label">Priority</lable>
                                                            <Select
                                                                options={Priority}
                                                                styles={{
                                                                    ...customStyle,
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        zIndex: 2,
                                                                    }),
                                                                }}
                                                                value={clientData?.priority}
                                                                placeholder="---"
                                                                onChange={(val) => {
                                                                    setClientData((preVal) => ({
                                                                        ...preVal,
                                                                        priority: val,
                                                                    }));
                                                                }}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#5757fe',
                                                                        primary: '#5757fe',
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-lg-3 col-md-6 col-sm-6 mt-4">
                                                <div className="radiobtn">
                                                    <input type="checkbox" value={clientData?.make_private} defaultChecked={data?.make_private ? true : false} onChange={(e) => setClientData({ ...clientData, make_private: e.target.checked })} />
                                                    <div className="label">Make Private</div>
                                                </div>
                                            </div>

                                            <div className="col-lg-3 col-md-6 col-sm-6 mt-4">
                                                <div className="radiobtn">
                                                    <input type="checkbox" value={clientData?.billable} defaultChecked={data?.billable ? true : false} onChange={(e) => setClientData({ ...clientData, billable: e.target.checked })} />
                                                    <div className="label">Billable</div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12 col-sm-12 mt-4 radiobtntime">
                                                <div className="radiobtn">
                                                    <input type="checkbox" value={clientData?.time_estimate} defaultChecked={data?.time_taken_estimate ? true : false} onChange={(e) => setClientData({ ...clientData, time_estimate: e.target.checked })} />
                                                    <div className="label">Time estimate</div>
                                                </div>

                                                {clientData?.time_estimate && (<div className="time">
                                                    <input type="number" value={clientData?.time_taken_hours} onChange={(e) => setClientData({ ...clientData, time_taken_hours: e.target.value })} />
                                                    <label className="label">Hrs</label>
                                                    <input type="number" value={clientData?.time_taken_minutes} onChange={(e) => setClientData({ ...clientData, time_taken_minutes: e.target.value })} />
                                                    <label className="label">Mins</label>
                                                </div>)}
                                            </div>

                                            <div className="col-lg-6 col-md-6 col-sm-6 mt-4">
                                                <div className="radiobtn">
                                                    <input type="checkbox" value={clientData?.repeat} defaultChecked={data?.repeat ? true : false} onChange={(e) => setClientData({ ...clientData, repeat: e.target.checked })} />
                                                    <div className="label">Repeat</div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6 col-sm-6 mt-4">
                                                <div className="radiobtn">
                                                    <input
                                                        type="checkbox"
                                                        checked={clientData?.independent_task}
                                                        onChange={(e) =>
                                                            setClientData({
                                                                ...clientData,
                                                                independent_task: e.target.checked,
                                                                dependentTask: null,
                                                            })
                                                        }
                                                    />
                                                    <div className="label">Task is dependent on another task</div>
                                                </div>

                                                {(clientData?.independent_task && clientData?.project) && (
                                                    <div className="mt-3">
                                                        <label className="label">Select Parent Task</label>
                                                        <Select
                                                            options={taskOptions}
                                                            value={clientData?.dependentTask}
                                                            onChange={(selected) =>
                                                                setClientData((prev) => ({
                                                                    ...prev,
                                                                    dependentTask: selected,
                                                                }))
                                                            }
                                                            placeholder="Select a parent task"
                                                            formatOptionLabel={option => <OptionRenderer data={option} />}
                                                            getOptionValue={(option) => option.id}
                                                            getOptionLabel={(option) => option.label}
                                                            styles={{
                                                                ...customStyle,
                                                                menu: (provided) => ({
                                                                    ...provided,
                                                                    zIndex: 5,
                                                                }),
                                                                control: (provided) => ({
                                                                    ...provided,
                                                                    boxShadow: 'none',
                                                                    border: '1px solid #ced4da',
                                                                }),
                                                                placeholder: (provided) => ({
                                                                    ...provided,
                                                                    color: '#6c757d',
                                                                }),
                                                            }}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#5757fe',
                                                                    primary: '#5757fe',
                                                                },
                                                            })}
                                                            isSearchable
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            {pathname === "/task/emptask/add" || pathname === "/task/emptask/edit" ? (
                <>
                    {mainContent}
                    <AddTaskModal isOpen={Addtaskmodal} onClose={closeTaskModal} addTaskCategory={props?.addTaskCategory} taskCategory={props?.taskCategory} loading={props?.loading} deleteTaskCategory={props?.deleteTaskCategory} deleteLoading={props?.deleteLoading} />

                    <AddLabelModal isOpen={Addlabelmodal} onClose={closeLabelModal} addTaskLabel={props?.addTaskLabel} taskLabel={props?.taskLabel} loading={props?.loading} deleteTaskLabel={props?.deleteTaskLabel} deleteLoading={props?.deleteLoading} />
                </>
            ) :
                (<>
                    {mainContent}
                    <AddTaskModal isOpen={Addtaskmodal} onClose={closeTaskModal} addTaskCategory={props?.addTaskCategory} taskCategory={props?.taskCategory} loading={props?.loading} deleteTaskCategory={props?.deleteTaskCategory} deleteLoading={props?.deleteLoading} />

                    <AddLabelModal isOpen={Addlabelmodal} onClose={closeLabelModal} addTaskLabel={props?.addTaskLabel} taskLabel={props?.taskLabel} loading={props?.loading} deleteTaskLabel={props?.deleteTaskLabel} deleteLoading={props?.deleteLoading} /></>
                )}
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        loading: state.taskReducer.loading,
        task: state.taskReducer.task,
        taskCategory: state.taskReducer.taskCategory,
        users: state.userReducer.users,
        user: state.authenticationReducer.user,
        deleteLoading: state.taskReducer.deleteLoading,
        taskLabel: state.taskReducer.taskLabel,
        timesheet: state.timesheetReducer.timesheet,
        project: state.projectReducer.project,
        projectMilestones: state.projectReducer.projectMilestones
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addTask: (data) => {
            dispatch(addTask(data));
        },
        updateTask: (id, data, showToast) => {
            dispatch(updateTask(id, data, showToast));
        },
        getUsers: (options) => {
            dispatch(getUsers(options));
        },
        getprojects: () => {
            dispatch(getprojects());
        },
        getTasks: () => {
            dispatch(getTasks())
        },
        addTaskCategory: (data) => {
            dispatch(addTaskCategory(data));
        },
        getTaskCategoryList: () => {
            dispatch(getTaskCategoryList());
        },
        deleteTaskCategory: (id) => {
            dispatch(deleteTaskCategory(id));
        },
        getTaskLabelList: () => {
            dispatch(getTaskLabelList());
        },
        addTaskLabel: (data) => {
            dispatch(addTaskLabel(data));
        },
        deleteTaskLabel: (id) => {
            dispatch(deleteTaskLabel(id));
        },
        addTimesheet: (data) => {
            dispatch(addTimesheet(data));
        },
        updateTimesheet: (id, data) => {
            dispatch(updateTimesheet(id, data));
        },
        getProjectMilestones: () => {
            dispatch(getProjectMilestones())
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(EmpProjectAddTask);
